<template>
  <a-layout class="container">
    <!-- 用户信息部分 -->
    <a-card class="profile-header">
      <a-row :gutter="16">
        <div class="header-avatar">
          <a-avatar size="large" :style="{ background: getRandomColor() }">{{
            getFirstLetterOfName(name)
          }}</a-avatar>
        </div>
        <a-col :span="14">
          <div class="user-info">
            <h2>{{ encryptName(name) }}</h2>
            <p>登录手机号码：{{ encryptPhoneNumber(phone) }}</p>
          </div>
        </a-col>
        <div :span="6" class="buttons">
          <a-button v-if="canOperate(['ORG_USER_CANCEL'])" type="default" @click="signOut">注销账号</a-button>
          <!-- <a-button type="default" @click="signOut">注销账号</a-button> -->
          <div style="display: inline-block; width: 8px"></div>
          <a-button v-if="whetherAccountExists == '1'" type="default" @click="changePW">{{
            psdType != 2 ? "修改密码" : "设置账号及密码"
          }}</a-button>
        </div>
      </a-row>
    </a-card>
    <!-- 账户信息部分 -->
    <a-card class="account-info">
      <a-row :gutter="16" v-for="(item, index) in personalInformation" :key="index">
        <div class="account-info-content">
          <a-col :span="24"
            ><span class="account-info-content-title">{{ item.title }}</span
            >{{ item.value }}</a-col
          >
        </div>
      </a-row>
    </a-card>
    <!-- 角色信息部分 -->
    <a-card class="role-info">
      <h3>我的角色</h3>
      <a-table :dataSource="roles" :columns="columns" :pagination="false" bordered />
    </a-card>
    <!-- 设置账号及密码 -->
    <InitializeAccount v-model="initModal" />
    <!-- 修改密码 -->
    <ChangePassword v-model="changePWModal" />
    <!-- 注销账号 -->
    <CancelAccount ref="CancelAccount" />
  </a-layout>
</template>

<script>
import { Avatar, Button, Card, Col, Layout, Row, Table } from "ant-design-vue";
import { get, post } from "../utils/http";
import InitializeAccount from "../layout/children/InitializeAccount.vue";
import ChangePassword from "../layout/children/ChangePassword.vue";
import CancelAccount from "../layout/children/CancelAccount.vue";
import { canOperate } from "@/utils/utils";

import api from "@/api";
export default {
  name: "IndividualCenter",
  components: {
    "a-layout": Layout,
    "a-card": Card,
    "a-row": Row,
    "a-col": Col,
    "a-avatar": Avatar,
    "a-button": Button,
    "a-table": Table,
    InitializeAccount: InitializeAccount,
    ChangePassword: ChangePassword,
    CancelAccount: CancelAccount,
  },
  data() {
    return {
      name: "",
      phone: "",
      roles: [],
      initModal: false,
      changePWModal: false,
      accountModal: false,
      psdType: 0, // 2 -设置账号密码 1&0-修改密码
      whetherAccountExists: localStorage.getItem("whetherAccountExists") || "0",
      columns: [
        { title: "角色", dataIndex: "roleName", key: "roleName", width: 150 },
        { title: "授权产品", dataIndex: "productNames", key: "productNames" },
      ],
      personalInformation: [
        {
          title: "账号名：",
          key: "loginAccount",
          value: "--",
        },
        {
          title: "所属组织：",
          key: "orgName",
          value: "--",
        },
        {
          title: "直接上级：",
          key: "leaderName",
          value: "--",
        },
        {
          title: "职务：",
          key: "jobPost",
          value: "--",
        },
        {
          title: "工号：",
          key: "jobNumber",
          value: "--",
        },
        {
          title: "兼职组织：",
          key: "partTimeOrgNames",
          value: "--",
        },
        {
          title: "状态：",
          key: "accountState", // 1是正常 2是禁用 3是离职
          value: "--",
        },
      ],
    };
  },
  mounted() {
    this.getData();
    this.initPsw();
  },
  methods: {
    canOperate(codes) {
      return canOperate(codes, '1');
    },
    signOut() {
      this.$refs.CancelAccount.accountAdminQuery();
    },
    initPsw() {
      if (this.whetherAccountExists != "1") {
        return;
      }
      post(api.queryAccountStatus, {}).then((res) => {
        this.psdType = res;
      });
    },
    // 加密手机号
    encryptPhoneNumber(phoneNumber) {
      if (!phoneNumber || phoneNumber.length < 7) {
        throw new Error("Invalid phone number");
      }
      const prefix = phoneNumber.slice(0, 3);
      const suffix = phoneNumber.slice(-4);
      const encrypted = `${prefix}****${suffix}`;
      return encrypted;
    },
    // 修改密码
    changePW() {
      this.psdType != 2 ? (this.changePWModal = true) : (this.initModal = true);
    },
    // 加密姓名
    encryptName(name) {
      if (!name || name.length === 0) {
        throw new Error("Invalid name");
      }

      if (name.length === 2) {
        return `${name.charAt(0)}*`;
      } else {
        return `${name.charAt(0)}*${name.charAt(name.length - 1)}`;
      }
    },
    getData() {
      let self = this;
      get(api.accountRoles, {}).then((res) => {
        if (res) {
          for (var key in res) {
            self.personalInformation.forEach((m) => {
              if (key === m.key) {
                if (key === "accountState") {
                  switch (res[key]) {
                    case "1":
                      m.value = "正常";
                      break;
                    case "2":
                      m.value = "禁用";
                      break;
                    case "3":
                      m.value = "离职";
                      break;

                    default:
                      m.value = "--";
                      break;
                  }
                } else {
                  m.value = res[key] || "--";
                }
              }
            });
          }
          self.name = res.name;
          self.phone = res.phone;
          if (res.roleList) {
            res.roleList.forEach((m, i) => {
              self.roles.push({
                key: i,
                roleName: m.roleName,
                productNames: m.productNames,
              });
            });
          }
        }
      });
    },
    getFirstLetterOfName(name) {
      // 检查名字是否是英文
      const isEnglish = /^[A-Za-z]+$/.test(name);
      if (name.length === 2) {
        // 名字是两个字，直接返回
        return name;
      } else if (name.length >= 3) {
        // 名字是三个字或以上，返回最后两个字
        return name.slice(-2);
      } else if (isEnglish) {
        // 名字是英文，返回英文首字母
        return name[0].toUpperCase();
      } else {
        // 名字不符合上述条件，返回空字符串或者抛出错误
        return "错误"; // 或者抛出错误
      }
    },
    getRandomColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      // return color;
      // 因为产品要求，返回了固定颜色
      return "#E8EEFA";
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  font-family: Arial, sans-serif;
}

.ant-card-bordered {
  border: none;
}

.ant-avatar-lg {
  width: 60px;
  height: 60px;
  /* line-height: 12px; */
  border-radius: 50%;
  margin-top: 4px;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  color: #446ebb;
}

.profile-header {
  background-color: #ffffff;
  // padding: 20px;
  margin-bottom: 20px;
  position: relative;

  .header-avatar {
    display: inline-block;
    float: left;
  }
}

.user-info {
  padding-left: 20px;
}

.user-info h2 {
  margin: 0 0 12px 0;
}

.user-info p {
  margin: 0;
  color: #888;
}

.buttons {
  margin-left: 10px;
  float: right;
}

.role-info {
  background-color: #ffffff;
  // padding: 20px;
  // margin-bottom: 20px;
}

.account-info {
  margin-bottom: 20px;
  padding-left: 20px;

  &-content {
    font-size: 14px;
    height: 24px;
    width: 100%;
    margin: 8px 0;
    color: #606266;

    &-title {
      color: #999;
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
}

a-table {
  margin-top: 10px;
}

.ant-table-thead > tr > th {
  // background-color: #f0f2f5;
}

.ant-layout {
  background: transparent;
}

.role-info h3 {
  margin-bottom: 16px;
}
</style>
